import React from 'react';
import AdminApiView from './AdminApiView';
import AdminWebhooksView from './AdminWebhooksView';
import SettingsContainerView from '../../settings/SettingsContainerView';

const AdminDeveloperView = () => (
  <SettingsContainerView title="Developer" parentTitle="Developer">
    <AdminWebhooksView />
    <AdminApiView />
  </SettingsContainerView>
);

export default AdminDeveloperView;
